import type {
  CampaignAutomationLeadParams,
  CampaignAutomationLeadRow,
  CampaignPipelineAutomationSummary,
} from "@/types/campaign-pipeline-automation";
import type { Page } from "@/types/pagination";

import { requestData } from "@/api/api-config";

export async function fetchCampaignPipelineAutomation(
  campaignId: string,
  pipelineId?: string,
): Promise<CampaignPipelineAutomationSummary | null> {
  return await requestData<CampaignPipelineAutomationSummary>(
    `opportunity/campaign/${campaignId}/pipeline-automation`,
    "get",
    { searchParams: pipelineId ? { pipelineId } : {} },
  );
}

export async function fetchCampaignAutomationLeads(
  campaignId: string,
  params: CampaignAutomationLeadParams,
): Promise<Page<CampaignAutomationLeadRow> | null> {
  const searchParams: Record<string, string | number> = {};
  if (params.stageId) searchParams.stageId = params.stageId;
  if (params.stepId) searchParams.stepId = params.stepId;
  if (params.automationFilter)
    searchParams.automationFilter = params.automationFilter;
  if (params.search) searchParams.search = params.search;
  if (params.page) searchParams.page = params.page;
  if (params.perPage) searchParams.perPage = params.perPage;

  return await requestData<Page<CampaignAutomationLeadRow>>(
    `opportunity/campaign/${campaignId}/pipeline-automation/leads`,
    "get",
    { searchParams },
  );
}
